// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1PMpF","footer":"ModalCreateQualiphyProcedure_footer__2tIAj","additionData":"ModalCreateQualiphyProcedure_additionData__17gan"};